import { Box, Card, Checkbox, Grid, Link, Stack, Tooltip } from '@mui/material';
import isEmpty from 'lodash-es/isEmpty';
import React from 'react';

import WsColors from '../../WsColors';
import { WsDotColors, WsDotIcon, WsDotTextColors } from '../WsDotIcon';
import ActiveJob from '../WsIcon/ActiveJob';
import Location from '../WsIcon/Location';
import Profile from '../WsIcon/Profile';
import Tag from '../WsIcon/Tag';
import { WsIconText } from '../WsIconText';
import { ChipsType, WsTagsList } from '../WsTagsList';
import { WsTypography, WsTypoColors, WsTypoVariants } from '../WsTypography';

import WsDetailsProps from './WsDetailsProps';

const WsDetailsCard = ({
  title = '',
  titleUrl = '',
  titleCode = '',
  clientName = '',
  locationsArray = [],
  tagsArray = [],
  rightChildren,
  footer,
  isCheckBox,
  checkBoxOnclick,
  isActiveCard,
  gridXs,
  skillsArray = [],
  underline = 'none',
  email = '',
  icon,
  detailsArray = [],
  postedByChildren,
  isSelected,
  disableCheckBox,
  remoteJob,
  jobSourceArray,
  onTitleClick,
  vmsFlag = false,
  visibilityFlag = false,
  onLocationClick = () => {},
  informationTemplates = [],
  evaluationTemplates = [],
  job,
}: WsDetailsProps) => (
  <Card>
    <Box p={2}>
      <Grid container item xs={12}>
        <Grid item xs={rightChildren ? 8 : 12}>
          <Box pl={1}>
            <Grid container xs={12}>
              <Stack direction="row">
                {isCheckBox ? (
                  <Tooltip
                    title={
                      disableCheckBox ? 'You can only Assign Jobs posted by you or your Team' : ''
                    }
                  >
                    <Checkbox
                      sx={{ p: 0 }}
                      checked={isSelected ?? false}
                      onClick={checkBoxOnclick}
                      size="small"
                      disabled={disableCheckBox}
                      style={{ pointerEvents: 'auto' }}
                    />
                  </Tooltip>
                ) : (
                  <></>
                )}
                {
                  <Grid container item xs={12}>
                    <Box pt={0.5} px={0.5}>
                      {icon && icon}
                      {!icon && (
                        <ActiveJob
                          color={isActiveCard ? WsColors.TheBlues400 : WsColors.TertiaryShades500}
                          color2={isActiveCard ? WsColors.TheBlues500 : WsColors.TertiaryShades600}
                        />
                      )}
                    </Box>
                    <Box pt={0.5}>
                      {isEmpty(titleUrl) && (
                        <WsTypography
                          variant={WsTypoVariants.TITLE}
                          color={isActiveCard ? WsTypoColors.BLACK : WsTypoColors.SECONDARY}
                          cursor="pointer"
                          onClick={onTitleClick}
                          bold={true}
                        >
                          {title}
                        </WsTypography>
                      )}
                    </Box>
                    {!isEmpty(titleUrl) && (
                      <Link href={titleUrl} underline={underline} color={WsColors.GenericRichBlack}>
                        <WsTypography
                          variant={WsTypoVariants.TITLE}
                          color={isActiveCard ? WsTypoColors.BLACK : WsTypoColors.SECONDARY}
                          cursor="pointer"
                          bold={true}
                        >
                          {title}
                        </WsTypography>
                      </Link>
                    )}
                    <Box px={0.5} pt={0.7} id="job_card_title">
                      <WsTypography
                        variant={WsTypoVariants.SUB_TITLE}
                        color={WsTypoColors.SECONDARY}
                        opacity={true}
                      >
                        {titleCode}
                      </WsTypography>
                    </Box>
                    {clientName && !/.*xxxxxx.*/.test(clientName) ? (
                      <Box pr={1} pt={0.5}>
                        <Link
                          href={`/client-details?tabIndex=0&isChild=true&name=${job?.companyName}&goBack=true&goBackUrl=/jobs&jobCode=${job?.jobCode}`}
                          underline={underline}
                          color={WsColors.GenericRichBlack}
                        >
                          <WsTypography
                            variant={WsTypoVariants.SUB_TITLE}
                            color={WsTypoColors.PRIMARY}
                            bold={true}
                            cursor="pointer"
                          >
                            {clientName}
                          </WsTypography>
                        </Link>
                      </Box>
                    ) : (
                      <Box pr={1} pt={0.5}>
                        <WsTypography
                          variant={WsTypoVariants.SUB_TITLE}
                          color={WsTypoColors.PRIMARY}
                          bold={true}
                        >
                          {clientName}
                        </WsTypography>
                      </Box>
                    )}
                    <Box pt={0.8}>
                      <WsDotIcon
                        color={isActiveCard ? WsDotColors.GREEN : WsDotColors.SENARY}
                        textColor={isActiveCard ? WsDotTextColors.GREEN : WsDotTextColors.SENARY}
                        value={isActiveCard ? 'Active' : 'Closed'}
                      />
                    </Box>
                  </Grid>
                }
              </Stack>
            </Grid>
          </Box>
        </Grid>
        {rightChildren && (
          <Grid item xs={4} container justifyContent="flex-end">
            {rightChildren}
          </Grid>
        )}
      </Grid>
      {postedByChildren && (
        <Grid item xs={12}>
          {postedByChildren}
        </Grid>
      )}
      <Grid container item xs={12} pl={1.5} py={1} spacing={1}>
        {detailsArray?.map((detailsObj, index) => (
          <Grid item xs={gridXs} key={index}>
            <WsIconText
              icon={detailsObj.icon ?? <></>}
              text={detailsObj.labelName ?? ''}
              textSize={WsTypoVariants.BODY1}
              opacity={true}
              popOverText={`${detailsObj.popOverText}`}
              textCursor="pointer"
            />
          </Grid>
        ))}
      </Grid>
      {!isEmpty(email) && (
        <Box p={1}>
          <WsIconText icon={<Profile />} text={email} opacity={true} />
        </Box>
      )}
      {!isEmpty(locationsArray) && (
        <Grid container item xs={12} pt={1} alignItems="center">
          <Box pt={0.5} pr={0.6}>
            <Location />
          </Box>
          <WsTypography
            variant={WsTypoVariants.SUB_TITLE}
            color={WsTypoColors.PRIMARY}
            cursor="pointer"
          >
            Location :
          </WsTypography>
          <WsTagsList
            chipArray={[remoteJob ? 'Remote' : '']
              .concat(
                locationsArray.map(
                  (location) =>
                    [location.city, location.state, location.country]
                      .filter((values) => values)
                      .toString() || location.continent
                )
              )
              .filter((val) => val != '')}
            count={3}
            type={ChipsType.SECONDARY}
            borderColorFlag={visibilityFlag && vmsFlag ? true : false}
            tagOnClick={() => vmsFlag && onLocationClick()}
          />
          {visibilityFlag && vmsFlag ? (
            <Grid item mr={1}>
              <WsTypography
                onClick={() => vmsFlag && onLocationClick()}
                variant={WsTypoVariants.BODY1}
                color={WsTypoColors.RED}
                cursor="pointer"
              >
                validate the location
              </WsTypography>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      )}
      {!isEmpty(skillsArray) && (
        <Grid container item xs={12} pt={1} alignItems="center">
          <Box pt={0.5} pr={0.6}>
            <Tag />
          </Box>
          <WsTypography
            variant={WsTypoVariants.SUB_TITLE}
            color={WsTypoColors.PRIMARY}
            cursor="pointer"
          >
            Skills :
          </WsTypography>
          <WsTagsList
            chipArray={skillsArray}
            count={3}
            type={ChipsType.PRIMARY}
            borderColorFlag={true}
          />
        </Grid>
      )}
      {!isEmpty(tagsArray) && (
        <Grid container item xs={12} pt={1} alignItems="center">
          <Box pt={0.5} pr={0.6}>
            <Tag />
          </Box>
          <WsTypography
            variant={WsTypoVariants.SUB_TITLE}
            color={WsTypoColors.PRIMARY}
            cursor="pointer"
          >
            Tags :
          </WsTypography>
          <WsTagsList chipArray={tagsArray} count={3} type={ChipsType.SECONDARY} />
        </Grid>
      )}
      {!isEmpty(jobSourceArray) && (
        <Grid container item xs={12} pt={1} alignItems="center">
          <Box pt={0.5} pr={0.6}>
            <Tag />
          </Box>
          <WsTypography
            variant={WsTypoVariants.SUB_TITLE}
            color={WsTypoColors.PRIMARY}
            cursor="pointer"
          >
            Job Source:
          </WsTypography>
          <WsTagsList chipArray={jobSourceArray ?? []} count={3} type={ChipsType.SECONDARY} />
        </Grid>
      )}
      {evaluationTemplates.length > 0 && (
        <Grid container item xs={12} pt={1} alignItems="center">
          <Box pt={0.5} pr={0.6}>
            <Tag />
          </Box>
          <WsTypography
            variant={WsTypoVariants.SUB_TITLE}
            color={WsTypoColors.PRIMARY}
            cursor="pointer"
          >
            Evaluation Templates :
          </WsTypography>
          <WsTagsList
            chipArray={evaluationTemplates.map((it: any) => it['templateName'])}
            count={3}
            type={ChipsType.SECONDARY}
            borderColorFlag={visibilityFlag && vmsFlag ? true : false}
          />
        </Grid>
      )}
      {informationTemplates.length > 0 && (
        <Grid container item xs={12} pt={1} alignItems="center">
          <Box pt={0.5} pr={0.6}>
            <Tag />
          </Box>
          <WsTypography
            variant={WsTypoVariants.SUB_TITLE}
            color={WsTypoColors.PRIMARY}
            cursor="pointer"
          >
            Information Templates :
          </WsTypography>
          <WsTagsList
            chipArray={informationTemplates.map((it: any) => it['templateName'])}
            count={3}
            type={ChipsType.SECONDARY}
            borderColorFlag={visibilityFlag && vmsFlag ? true : false}
          />
        </Grid>
      )}
    </Box>
    {footer}
  </Card>
);

export default WsDetailsCard;
